import {createContext, useContext} from "react";
import type {OrganizationalUnit} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/organizationalUnitsWorkspaceCapability/domain/OrganizationalUnit";
import type {OrganizationalUnitTemplate} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/organizationalUnitsWorkspaceCapability/domain/OrganizationalUnitTemplate";
import {WorkspaceContext} from "~/contexts/workspaceContext";

type OrganizationalUnitsContextData = Array<OrganizationalUnit>;
type OrganizationalUnitTemplatesContextData = Array<OrganizationalUnitTemplate>;

export const OrganizationalUnitsContext = createContext<OrganizationalUnitsContextData | undefined>(
    undefined,
);
export const OrganizationalUnitTemplatesContext = createContext<OrganizationalUnitTemplatesContextData | undefined>(undefined);

export function useOrganizationalUnits(): OrganizationalUnitsContextData {
    const organizationalUnitsContextData = useContext(OrganizationalUnitsContext);
    if (organizationalUnitsContextData === undefined) {
        throw new Error("OrganizationalUnitsContext.Provider not found");
    }

    return organizationalUnitsContextData;
}

export function useOrganizationalUnitTemplatesForOus(): OrganizationalUnitTemplatesContextData {
    const workspaceContextData = useContext(WorkspaceContext);
    const organizationalUnitTemplatesContextData = useContext(OrganizationalUnitTemplatesContext);
    const organizationalUnitTemplates = workspaceContextData?.organizationalUnitTemplates ?? organizationalUnitTemplatesContextData;
    if (organizationalUnitTemplates === undefined) {
        throw new Error("WorkspaceContext.Provider or OrganizationalUnitTemplatesContext.Provider not found");
    }

    return organizationalUnitTemplates;
}
